export const TREND_DATA = [
  {
    id: 'RT0020',
    industryId: 'RTG0020',
  },
  {
    id: 'RT0019',
    industryId: 'RTG0019',
  },
  {
    id: 'RT0018',
    industryId: 'RTG0018',
  },
]

export const EACH_YEAR_RATIO = [
  {
    id: 'RT0020',
    industryId: 'RTG0020',
    topColor: '#EDF5FE',
    bottomColor: '#006AA6',
  },
  {
    id: 'RT0019',
    industryId: 'RTG0019',
    topColor: '#fef7e2',
    bottomColor: '#FFCD60',
  },
  {
    id: 'RT0018',
    industryId: 'RTG0018',
    topColor: '#f7e6e8',
    bottomColor: '#FF596A',
  },
]

export const EACH_YEAR_NET = [{ id: 'RT0001' }, { id: 'RT0040' }]
